import { render, staticRenderFns } from "./FormTranslation.vue?vue&type=template&id=b7419bd2&"
import script from "./FormTranslation.vue?vue&type=script&lang=js&"
export * from "./FormTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports